import axios from "axios";

const get_cart_total = () => {
	let carttotal_line = document.querySelector("#carttotal");
	let carttotal_line_mobile = document.querySelector("#carttotalmobile");
	let selected_price = document.querySelector("#selected_price");
	if (carttotal_line && selected_price) {
		let form_data = new FormData();
		form_data.append("action", "get_cart_total");
		axios.post(ajaxurl, form_data)
			.then((data) => {
				carttotal_line.innerHTML = data.data.count;
				carttotal_line_mobile.innerHTML = data.data.count;
				selected_price.innerHTML = `${data.data.total}.-CHF`;
				carttotal_line.classList.add("animated");
				carttotal_line_mobile.classList.add("animated");
				setTimeout(() => {
					carttotal_line.classList.remove("animated");
					carttotal_line_mobile.classList.remove("animated");
				}, 1100);
			})
			.catch((err) => {
				console.log(err);
			});
	} else if (carttotal_line) {
		let form_data = new FormData();
		form_data.append("action", "get_cart_total");
		axios.post(ajaxurl, form_data)
			.then((data) => {
				carttotal_line.innerHTML = data.data.count;
				carttotal_line_mobile.innerHTML = data.data.count;
				if (selected_price) {
					selected_price.innerHTML = `${data.data.total}.-CHF`;
				}
				carttotal_line.classList.add("animated");
				carttotal_line_mobile.classList.add("animated");
				setTimeout(() => {
					carttotal_line_mobile.classList.remove("animated");
				}, 1100);
			})
			.catch((err) => {
				console.log(err);
			});
	}
};

window.addEventListener("DOMContentLoaded", () => {
	get_cart_total();
	let products = document.querySelectorAll(".customshop .product");
	let special_products = document.querySelectorAll("#pricing_table .special_button");
	if (products) {
		products.forEach((el) => {
			el.addEventListener("click", () => {
				el.classList.add("animated");
				if (el.classList.contains("selected")) {
					let form_data = new FormData();
					form_data.append("action", "custom_remove_from_cart");
					form_data.append("product", el.dataset.id);
					axios.post(ajaxurl, form_data)
						.then(() => {
							get_cart_total();
							el.classList.remove("selected");
							setTimeout(() => {
								el.classList.remove("animated");
							}, 1000);
						})
						.catch((err) => {
							console.log(err);
							setTimeout(() => {
								el.classList.remove("animated");
							}, 1000);
						});
				} else {
					let form_data = new FormData();
					form_data.append("action", "custom_add_to_cart");
					form_data.append("product", el.dataset.id);
					axios.post(ajaxurl, form_data)
						.then(() => {
							get_cart_total();
							el.classList.add("selected");
							setTimeout(() => {
								el.classList.remove("animated");
							}, 1000);
						})
						.catch((err) => {
							console.log(err);
							setTimeout(() => {
								el.classList.remove("animated");
							}, 1000);
						});
				}
			});
		});
	}
	if (special_products) {
		special_products.forEach((el) => {
			el.addEventListener("click", () => {
				let form_data = new FormData();
				form_data.append("action", "custom_add_to_cart");
				form_data.append("product", el.dataset.id);
				axios.post(ajaxurl, form_data)
					.then(() => {
						window.location.href = "https://thedotgood.net/cart";
					})
					.catch((err) => {
						console.log(err);
					});
			});
		});
	}
});
